/* eslint-disable react-hooks/exhaustive-deps */
import { FilterOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from 'styles/components/selectDepartments.module.scss';
import { FILTERS_SEARCH_PARAMS } from 'utils/constants';

const SelectDepartments = ({ departments, loading, ...props }) => {
  const [departmentFilter, setDepartmentFilter] = useState(null);
  const [currentQueryParameters, setSearchParams] = useSearchParams();

  useEffect(() => {
    setDepartmentFilter(
      currentQueryParameters.get(FILTERS_SEARCH_PARAMS.DEPARTMENT)
    );
  }, [currentQueryParameters]);

  return (
    <Select
      showSearch
      popupMatchSelectWidth={false}
      prefix={<FilterOutlined />}
      style={{ marginRight: 10, width: 240 }}
      placeholder="All departments"
      loading={loading}
      size="small"
      {...props}
      options={[
        {
          value: null,
          label: (
            <label style={{ display: 'flex', alignItems: 'center' }}>
              <div
                className={styles.colorDepartment}
                style={{ backgroundColor: 'black' }}
              ></div>
              <span>All departments</span>
            </label>
          ),
        },
        ...(departments && departments.status === 'LIVE'
          ? [
              {
                label: (
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <img
                      src="/img/logo/linky.png"
                      width={22}
                      height={22}
                      alt="linky"
                    />
                    &nbsp; Departments from Linky
                  </label>
                ),
                value: 'linky',
                options:
                  departments.departments.length > 0
                    ? departments.departments.map((d) => ({
                        value: d._id,
                        label: (
                          <label
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <div
                              className={styles.colorDepartment}
                              style={{ backgroundColor: d.color }}
                            ></div>
                            <span>{`${d.value}`}</span>
                          </label>
                        ),
                      }))
                    : [
                        {
                          value: undefined,
                          label: (
                            <label>
                              <span>No departments are defined in Linky</span>
                            </label>
                          ),
                          disabled: true,
                        },
                      ],
              },
            ]
          : [
              {
                label: (
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <img
                      src="/img/logo/linky.png"
                      width={22}
                      height={22}
                      alt="linky"
                    />
                    &nbsp; Departments from Linky
                  </label>
                ),
                value: 'linky',
                options: [
                  {
                    label: (
                      <div>
                        <a
                          href="https://buddieshr.com/linky?ref=clappy_app"
                          target="_blank"
                          rel="noreferrer"
                          style={{ color: '#2d80e6' }}
                        >
                          {departments?.status === 'UNINSTALLED'
                            ? 'Re-install Linky'
                            : 'Install Linky'}
                        </a>{' '}
                        &nbsp;
                        <span style={{ color: 'black' }}>
                          to filter by department
                        </span>
                      </div>
                    ),
                    value: undefined,
                    disabled: true,
                  },
                ],
              },
            ]),
      ]}
      onChange={(value) => {
        if (!value) {
          currentQueryParameters.delete('DEPARTMENT');
          setDepartmentFilter(null);
        } else {
          currentQueryParameters.set('DEPARTMENT', value);
          setDepartmentFilter(value);
        }
        setSearchParams(currentQueryParameters);
      }}
      value={departmentFilter}
    />
  );
};

export default SelectDepartments;
